// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wpcm-target-achieved {\n  margin: 15px 0;\n  padding: 10px;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  border-radius: 4px;\n  color: #155724;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
